export const workflowObject = {
  workflowID: "",
  nodeName: "",
  workflowName: "",
  workflowDescription: "",
  isActive: true,
  filters: [
    {
      key: "",
      value: "",
      operator: "",
    },
  ],
  previousNode: [],
  actions: [],
  noActions: [],
  nextNodes: [],
  stage: 1,
};

export function objectFromResponseData(responseData) {
  return {
    workflowID: responseData._id,
    workflowName: responseData.workflow_name,
    workflowDescription: responseData.description,
    isActive: true,
    executionFlow: responseData.execution_flow,
    filters: responseData.conditions || [
      {
        key: "",
        value: "",
        operator: "",
      },
    ],
    previousNode: responseData.previous_node,
    actions: responseData?.yes_actions ? responseData?.yes_actions[0] : "",
    nextNodes: responseData.next_workflow_id,
    stage: responseData.stage,
    noActions: responseData?.no_actions ? responseData?.no_actions[0] : "",
  };
}

export function objectFromFormData(formData) {
  return {
    is_active: true,
    stage: formData.stage,
    description: formData.workflowDescription,
    workflow_name: formData.workflowName,
    execution_flow: formData.executionFlow,
    conditions: formData.filters,
    previous_node: [],
    no_actions: [formData.noActions],
    yes_actions: [formData.actions],
    next_workflow_id: [],
  };
}
